<template>
    <v-app id="app">

        <v-scroll-y-transition>
        <div v-if="usePayPall" style="height: 100%; width: 100%">
            <app-pay-pall
                    :serviceIdSelected="serviceIdNumber"
                    :telephoneNumberEntered="processedNumber"
            ></app-pay-pall>
        </div>
        </v-scroll-y-transition>


        <div  v-if="usePayPall == false" id="container-area">
            <div  id="mobile-version">

                <div id="user-info-section">
                    <v-overlay
                            absolute="absolute"
                            opacity="0.7"
                            :value="overlay">
                        <div id="cookie-overlay-main">
                            <div id="cookie-header">
                                <v-icon id="cookie-icon">fas fa-cookie-bite</v-icon>
                            </div>
                            <div id="cookie-info-content">
                                <div id="cookie-info-header"> Our Cookie Policy </div>
                                <div id="cookie-info-disclaimer">
                                    This website uses cookies to give you the best possible experience on our site
                                </div>
                                <div id="cookie-info-more">
                                    <v-btn @click="viewCookiePolicy" id="cookie-info-more-button" text>Learn More</v-btn>
                                </div>
                            </div>
                            <div id="cookie-accept">
                                <v-btn id="cookie-accept-button" height="50%" max-width="80%" min-width="65%" color="#000000" @click="overlay = false; consentToCookies()">
                                    Continue
                                </v-btn>
                            </div>
                        </div>
                    </v-overlay>

                    <v-stepper id="manual-stepper" v-model="e1">
                        <v-stepper-header id="manual-stepper-header">
                            <v-stepper-step style="display: none" color="#997A00" :complete="e1 > 1" step="1"></v-stepper-step>
                            <v-divider></v-divider>
                            <v-stepper-step style="display: none" color="#997A00" step="2"></v-stepper-step>
                        </v-stepper-header>
                        <v-stepper-items id="manual-stepper-items" >
                            <v-stepper-content v-resize="resizeWindow" class="stepper-content" step="1">
                                <div class="item-content" v-bind:style="{ width: computedWidth, height: computedHeight }">
                                    <div class="item-container">
                                        <div class="container-top">
                                            Enter Your Phone Number
                                        </div>
                                        <div class="container-middle-telephone">
                                            <div style="height: 20%; width: 100%; "></div>
                                            <div style="height: 80%; width: 100%;">
                                                <div style="width: 100%; height: 20%; display: flex; justify-content: center; align-items: center">

                                                    <div style="width: 90%">
                                                        <v-text-field background-color="#FFFFFF" style="transform: scale(0.9);"

                                                                      prefix=" "
                                                                      :prepend-icon="enterNumberIcon"
                                                                      hint="Required format 04########"
                                                                      clearable
                                                                      color="black"
                                                                      label="Your Phone Number"
                                                                      v-model="userSelectedTelephoneNumber"
                                                                      v-mask="mask"
                                                                      :error-messages="numberErrorMessage"
                                                        >

                                                        </v-text-field>
                                                    </div>

                                                </div>

                                                <div style="width: 100%; height: 70%; display: flex; justify-content: center; align-items: center">

                                                    <div style="width: 90%">
                                                        <v-text-field :disabled="disableConfirm" background-color="#FFFFFF" style="transform: scale(0.9);"

                                                                      prefix=" "
                                                                      :prepend-icon="confirmNumberIcon"
                                                                      hint="Required format 04########"
                                                                      clearable
                                                                      color="black"
                                                                      label="Confirm Phone Number"
                                                                      v-model="confirmNumberInput"
                                                                      v-mask="mask"
                                                                      :error-messages="errorMessage"
                                                        >

                                                        </v-text-field>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                        <div class="container-bottom">
                                            <v-btn class="text-none" style="color: white;" height="50%" width="50%" :disabled="buttonDisabled" color="#997A00" id="cont-btn"  @click="usePayPall = true; serviceIdNumber = 3">
                                                Continue <v-icon style="padding-left: 10px; font-size: 4.5vw">fas fa-chevron-right</v-icon>
                                            </v-btn>
                                        </div>
                                    </div>
                                </div>
                            </v-stepper-content>

                        </v-stepper-items>
                    </v-stepper>
                    <div id="logo-area">
                        <div class="logo-image-holder" v-bind:style="{backgroundImage: computedGirlTextLogo}"></div>
                        <div class="logo-image-holder" style="  filter: brightness(0) invert(1);" v-bind:style="{backgroundImage: computedChatTubeLogo}"></div>
                        <div class="logo-image-holder" style="  filter: brightness(0) invert(1);" v-bind:style="{backgroundImage: computedBabeFlirtLogo}"></div>
                        <div class="logo-image-holder" v-bind:style="{backgroundImage: computedGayTextLogo}"></div>
                    </div>
                </div>

            </div>

            <div id="display-version">

                <div style="width: 100%; height: 20%;">
                    <v-scroll-x-transition>
                        <div  style="width: 100%; height: 100%;">
                            <div style="float: left ;width: 20%; height: 100%;display: flex; justify-content: center; align-items: center;">

                            </div>
                            <div style=" padding-right: 20% ;float: left;width: 80%; height: 100%;display: flex; justify-content: center; align-items: center; color: white; font-weight: bold; font-size: 4vh;">
                                {{desktopViewText}}
                            </div>
                        </div>
                    </v-scroll-x-transition>
                </div>

                <div style="width: 100%; height: 55%; display: flex; justify-content: center; align-items: center">

                    <v-card flat color="transparent"  style="width: 80%; height: 100%">
                        <v-scroll-x-transition>
                            <div v-if="desktopShowNumbers" style="width: 100%; height: 100%">
                                <div style="width: 100%; height: 33%; display: flex; justify-content: left; align-items: center">
                                    <v-text-field  style="transform: scale(0.9);"
                                                   :prepend-icon="enterNumberIcon"
                                                   hint="Required format 04########"
                                                   clearable
                                                   label="Your Phone Number"
                                                   color="white"
                                                   dark
                                                   v-model="userSelectedTelephoneNumber"
                                                   v-mask="mask"
                                                   :error-messages="numberErrorMessage"
                                    ></v-text-field>
                                </div>
                                <div style="width: 100%; height: 33%; display: flex; justify-content: left; align-items: center">
                                    <v-text-field :disabled="disableConfirm" style="transform: scale(0.9);"
                                                  hint="Required format 04########"
                                                  clearable
                                                  :prepend-icon="confirmNumberIcon"
                                                  color="white"
                                                  dark
                                                  label="Confirm Phone Number"
                                                  v-model="confirmNumberInput"
                                                  v-mask="mask"
                                                  :error-messages="errorMessage"
                                    ></v-text-field>
                                </div>
                                <div style="width: 100%; height: 33%; display: flex; justify-content: center; align-items: center">
                                    <v-btn dark class="text-none" height="50%" width="30%" :disabled="buttonDisabled" color="#997A00" id="cont-btn3" @click="usePayPall = true; serviceIdNumber = 3">
                                        Continue <v-icon style="padding-left: 10px; font-size: 2vh">fas fa-chevron-right</v-icon>
                                    </v-btn>
                                </div>
                            </div>
                        </v-scroll-x-transition>

                    </v-card>



                </div>

                <div style="width: 50%; height: 10%; margin-left: auto; margin-right: auto">
                    <div class="logo-image-holder" v-bind:style="{backgroundImage: computedGirlTextLogo}"></div>
                    <div class="logo-image-holder" style="  filter: brightness(0) invert(1);" v-bind:style="{backgroundImage: computedChatTubeLogo}"></div>
                    <div class="logo-image-holder" style="  filter: brightness(0) invert(1);" v-bind:style="{backgroundImage: computedBabeFlirtLogo}"></div>
                    <div class="logo-image-holder" v-bind:style="{backgroundImage: computedGayTextLogo}"></div>
                </div>

                <div style="width: 100%; height: 15%">
                    <div style="height: 30%; width: 100%; color: white; font-size: 0.75vw; display: flex; justify-content: center; align-items: center; padding-right: 10%; padding-left: 10%">
                        You must be 18+ and be the bill payer or have the bill payers permission to use this service. To stop all messages text STOP to 85722. Costs are plus your standard network charge. You will receive free marketing messages by signing up to this service, text XSTOP to 85722 at any time to opt out. Service Provided by All Points North Publications Ltd, LS1 6ER. Customer Service: 03303330320
                    </div>

                    <div style="height: 30%; width: 100%; color: white; font-size: 0.75vw; display: flex; justify-content: center; align-items: center; padding-right: 10%; padding-left: 10%">
                        Copyright © 2019 - 2020 All Points North Publications . All rights reserved.
                    </div>

                    <div style="height: 25%; width: 100%; display: flex; justify-content: center; align-items: center;">
                        <v-avatar size="25%" style="height: auto; max-width: 100%;" tile>
                            <img
                                    :src="logoVisa"
                                    alt="Visa Verified"
                            >
                        </v-avatar>
                    </div>

                </div>



            </div>
        </div>


    </v-app>

</template>

<script>
import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import payPalBundles from '@/components/bundles/bundles.vue'

Vue.use(Vuetify)

export default {
  components: {
    appPayPall: payPalBundles
  },

  data () {
    return {

        desktopViewText: "Select the Service Number",

        showTitleDesktop:false,
        desktopShowNumbers: false,
        desktopShowService: false,

      enterNumberIcon: 'fas fa-hashtag',
      confirmNumberIcon: 'fas fa-hashtag',

      desktopAnimation: false,
      pageName: 'Enter Your Number',

      desktopOverlay: false,
      usePayPallDesktop: false,

      mask: '##############',
      mobileNumberInput: '',
      confirmNumberInput: '',
      errorMessage: '',
      numberErrorMessage: '',
      disableConfirm: true,
      processedNumber: '',

      overlay: '',
      // Logos Start
        logoVisa: require('@/images/logos/visa.png'),
      logoChatTube: require('@/images/logos/chatTube.png'),
      logoBabeFlirt: require('@/images/logos/babeflirt.png'),
      logoGayTxt: require('@/images/logos/gayText.png'),
      logoGirlTxtW: require('@/images/logos/girlTextW.png'),
      // Logos End
      buttonDisabled: true, // Boolean to dynamically disable a button
      max: 11, // Specifies what is the max amount of characters the user can enter
      placeholderText: '61XXXXXXXXX', // Defines the placeholder text
      userSelectedTelephoneNumber: '', // The telephone number the user has entered
      serviceIdNumber: '', // As australia so automatically will define the service number as 3
      e1: 0, // Left in case if multiple AUS service will be used currently only 1
      height: '410px', // Height of card
      width: '100px', // Width of card
      usePayPall: false, // Defines if to show bundle component
      // Dynamic Size Start Not sure why X not defined
      windowSize: {
        y: 0
      }
      // Dynamic Size End
    }
  },
  watch: {

    // Checks if telephone nymber has been entered if not then disable button
    userSelectedTelephoneNumber: function (ustn) {
      this.convertNumber()

      if (ustn.length == 10 && ustn.startsWith('04')) {
        this.numberErrorMessage = ''
        this.disableConfirm = false
        this.enterNumberIcon = 'fas fa-check'
      } else if (ustn.length == 10 && !ustn.startsWith('04')) {
        this.numberErrorMessage = 'The provided number has to start with 04'
        this.disableConfirm = true
        this.enterNumberIcon = 'fas fa-times'
      } else if (ustn.length <= 9) {
        this.numberErrorMessage = 'The provided number is too short'
        this.disableConfirm = true
        this.enterNumberIcon = 'fas fa-times'
      } else if (ustn.length >= 11) {
        this.numberErrorMessage = 'The provided number is too long'
        this.disableConfirm = true
        this.enterNumberIcon = 'fas fa-times'
      }
    },

    confirmNumberInput: function (v) {
      if (v != this.userSelectedTelephoneNumber && v.length == 10) {
        this.errorMessage = 'Entered numbers does not match'
        this.buttonDisabled = true
        this.confirmNumberIcon = 'fas fa-times'
      } else if (v != this.userSelectedTelephoneNumber && v.length <= 11) {
        this.errorMessage = 'Entered numbers does not match'
        this.buttonDisabled = true
        this.confirmNumberIcon = 'fas fa-times'
      } else if (v != this.userSelectedTelephoneNumber && v.length >= 9) {
        this.errorMessage = 'Entered numbers does not match'
        this.buttonDisabled = true
        this.confirmNumberIcon = 'fas fa-times'
      } else if (v == this.userSelectedTelephoneNumber && v.length == 10) {
        this.errorMessage = ''
        this.buttonDisabled = false
        this.confirmNumberIcon = 'fas fa-check'
      }
    }

  },
  mounted: function () {
      this.switchDesktopViews()
    setTimeout(() => this.resizeWindow(), 500) // On mounted checks div area and applies other styling for it
    document.title = 'Chattube - Australia' // Assigns document title

    this.desktopOverlay = true
  },

  computed: {
    // Computes Chat Tube Logo
    computedChatTubeLogo: function () {
      this.logoChatTube = 'url(' + this.logoChatTube + ')'
      return this.logoChatTube
    },
    // Computes Girl Text Logo
    computedGirlTextLogo: function () {
      this.logoGirlTxtW = 'url(' + this.logoGirlTxtW + ')'
      return this.logoGirlTxtW
    },

    // Computes Babe Flirt Logo
    computedBabeFlirtLogo: function () {
      this.logoBabeFlirt = 'url(' + this.logoBabeFlirt + ')'
      return this.logoBabeFlirt
    },

    // Computes gay Text Logo
    computedGayTextLogo: function () {
      this.logoGayTxt = 'url(' + this.logoGayTxt + ')'
      return this.logoGayTxt
    },

    // Computes The height of the card
    computedHeight: function () {
      return this.height
    },
    // Computes The width of the card
    computedWidth: function () {
      return this.width
    }
  },
  methods: {

      switchDesktopViews() {
          this.desktopShowService = false
          setTimeout(() => this.desktopShowNumbers = true, 500)
          this.desktopViewText = 'Enter Your Phone Number'
          this.showTitleDesktop = false,
              setTimeout(() => this.showTitleDesktop = true, 500)
      },

    overlayTrigger () {
      this.desktopOverlay = false
      setTimeout(() => this.desktopOverlay = true, 500)
      this.pageName = 'Choose Your Bundle'
    },

    convertNumber () {
      if (this.userSelectedTelephoneNumber.startsWith(0)) {
        this.editNumber = this.userSelectedTelephoneNumber.substr(1, 11)
        this.processedNumber = '61' + this.editNumber
      }
    },

    consentToCookies () { // Create a cookie
      $cookies.set('cookiePolicy', 'Yes', '2y')
    },
    viewCookiePolicy () { // Transfers user to cookie policy page
      sessionStorage.setItem('cameFromHere', location.href) // Create session item of users url which was active when they clicked on the button
      location.replace(location.origin + '/cookie-policy') // Transfers user to cookie policy
    },
    // Reads the width and height of the manual-stepper-items div and assigns them to width and height, then applied by computed.
    resizeWindow () {
      this.windowSize = { x: document.getElementById('manual-stepper-items').clientWidth, y: document.getElementById('manual-stepper-items').clientHeight }
      this.width = this.windowSize.x + 'px'
      this.height = this.windowSize.y + 'px'
    }
  },
  created () {
    document.write('<meta name="viewport" content="width=device-width,height=' + window.innerHeight + ', initial-scale=1.0">')
    document.write('<meta name="theme-color" content="#050505">')
    document.write('<meta name="apple-mobile-web-app-capable" content="yes">')
    document.write('<meta name="apple-mobile-web-app-status-bar-style" content="black">')

    setTimeout(() => this.desktopAnimation = true, 500)

    if ($cookies.get('cookiePolicy') == 'Yes') { // Checks if policy has been accepted if yes do nothing if no show overlay
      this.overlay = false
    } else {
      this.overlay = true
    }
  }
}
</script>

<style scoped>
    html, body {
        height: 100%;
        margin: 0;
        color: black;
        background: black;
    }

    #app {
        width: 100%;
        height: 100%;

    }

    #container-area {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        text-align: center;
        color: black;
        background-image: url("../../../images/backgrounds/babeflirtM.jpg");
        width: 100%;
        height: 100%;
        background-size: cover;
    }
    .logo-image-holder {

        width: 25%;
        height: 100%;
        float: left;
        background-size: 70%;
        background-position: center;

    }


    @media only screen and (min-width: 768px) {
        #mobile-version {
            width: 100%;
            height: 100%;
            display: none;
        }
        #display-version {
            width: 100%;
            height: 100%;
            background-image: url("../../../images/backgrounds/babeflirtD.jpg");
            background-size: cover;
        }
        #cont-btn3 {
            font-size: 2.5vh;
            border-radius: 5px;
            color: white
        }

    }



    @media only screen and (max-width: 768px) {
        #mobile-version {
            width: 100%;
            height: 100%;
        }
        #display-version {
            display: none;
        }

        #user-info-section {
            height: 100%;
            width: 100%;
        }

        #manual-stepper {
            font-family: 'Avenir', Helvetica, Arial, sans-serif;
            text-align: center;
            color: black;
            /*background-image: url("../../../images/backgrounds/babeflirtM.jpg");*/
            background: linear-gradient(to top, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 59%, rgba(0, 0, 0, 0.75) 100%), url('../../../images/backgrounds/babeflirtM.jpg') no-repeat;;
            width: 100%;
            height: 95%;
            background-size: cover;

        }

        #manual-stepper-header {
            width: 50%;
            height: 10%;
            margin-right: auto;
            margin-left: auto;
            box-shadow: none;
            border-radius: 20px;
        }

        #manual-stepper-items {

            height: 93%;
            width: 100%;

        }

        .stepper-content {

        }

        .item-content {
            padding: 5%;

        }

        .item-container {
            background-color: white;
            height: 100%;
            width: 100%;
            border-radius: 5px;
        }

        /*NEEDED FOR VUE*/
        .v-stepper__wrapper {
            height: 100%;

        }

        /*NEEDED FOR VUE*/
        .v-stepper__content {
            padding: 0;
            height: 100%;
        }

        .container-top {
            width: 100%;
            height: 20%;

            display: flex;
            justify-content: center;
            align-items: center;
            font-weight: bold;
            font-size: 3vh;
            color: rgba(0, 0, 0, 0.5);
        }

        .container-middle {
            width: 100%;
            height: 60%;
            display: flex;
            justify-content: center;
            align-items: center;
            font-weight: bold;

        }

        .container-middle-telephone {
            width: 100%;
            height: 60%;
            font-weight: bold;

        }

        .container-bottom {
            width: 100%;
            height: 20%;

        }

        #cont-btn {
            font-size: 3.5vw;
            border-radius: 5px;
            color: white
        }

        #cont-btn2 {
            font-size: 3.5vw;
            border-radius: 5px;
            color: white
        }

        #telephone-input {

            height: 40%;
            width: 80%;
            border-style: solid;
            border-radius: 10px;
            font-size: 6vw;
            color: rgba(0, 0, 0, 0.7);
            text-align: center;

        }

        ::placeholder {
            color: rgba(0, 0, 0, 0.45);
            opacity: 1; /* Firefox */
        }

        #character-info {

            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 2.5vw;
            padding-bottom: 1vw;
            color: rgba(0, 0, 0, 0.6);
        }

        #logo-area {
            width: 100%;
            height: 5%;
            margin: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            padding-left: 2.5%;
            padding-right: 2.5%;

        }

        #cookie-overlay-main {
            height: 70vh;
            width: 80vw;
            background-color: white;
            border-radius: 5px
        }

        #cookie-header {
            height: 40%;
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center
        }

        #cookie-info-content {
            height: 40%;
            width: 100%;
            color: black
        }

        #cookie-info-header {
            height: 40%;
            width: 100%;
            font-weight: bold;
            font-size: 6vw
        }

        #cookie-icon {

            font-size: 17.5vh;
            color: black;

        }

        #cookie-info-more {
            height: 10%;
            width: 100%;
            font-size: 4vw;
        }

        #cookie-info-more-button {
            color: black;
            text-decoration: underline;
            font-size: 3vw;
            font-weight: bold
        }

        #cookie-info-disclaimer {
            height: 40%;
            width: 100%;
            font-size: 4vw;
            padding-left: 5%;
            padding-right: 5%;
        }

        #cookie-accept {
            height: 20%;
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center
        }

        #cookie-accept-button {
            font-size: 3vw;
        }

    }

</style>
